import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Nominee-updation-2023.css";

function NomineeUpdation() {
  return (
      <>
        <div className="nomineeupdation2023_page">
        <section className="nomineeupdation2023_section">
            <div className="container">
              <h1>Nominee Updation in Trading account by Sep 30, 2023</h1>
                <p>
                It is our continuous endeavor to provide the best of services to our customers & ensure ease of trade. As per SEBI circular bearing circular number-
            </p>
            <p>SEBI/HO/MIRSD/RTAMB/CIR/P/2021/601 dated July 23,2021 & SEBI/HO/MIRSD/MIRSD_RTAMB/P/CIR/2022/23 February 24,2022 , it is mandatory to update 
                NOMINATION in your trading and Demat account.</p>
            <p>We, therefore, request you to kindly update the nomination in your account on or before 31st March 2023 by clicking on the below-mentioned link:</p>
            <p><a href="http://ekyc.moneysukh.com:9000/directpan.aspx">http://ekyc.moneysukh.com:9000/directpan.aspx</a></p>
            <p>Failure to update the required details within the stipulated time, will unfortunately result in marking your
                 account as ‘Disabled’ due to which you will not be allowed to place any trades.</p>
            <p>Kindly ignore if you have already updated nominee in your account.</p>
            <p>We look forward to your seamless and continued investment journey with us.</p>
            <p>For any queries, feel free to connect with us at <a href="callto:9638238000">
                <strong>91-96382-38000</strong></a> or write us at <a href="mailto:support@moneysukh.com">
                    support@moneysukh.com</a>
                    </p>
            </div>
              
        </section>  
        </div>  
    </>
  );
}
export default NomineeUpdation;
